<div class="request-form-container">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{width: '450px'}" [acceptLabel]="translate('Yes')" [rejectLabel]="translate('No')"></p-confirmDialog>

  <div class="d-flex mb-4 flex-wrap">
    <!-- Only show edit button and status for existing requests -->
    <div class="d-flex ms-auto align-items-center gap-3 flex-wrap w-100" *ngIf="isViewMode">
      <!-- Edit Button at top - only show if not approved/rejected -->
      <!-- <button *ngIf="!isEditMode && permission?.status === 'PENDING' && this.hasPermission('PERMISSION_REQUESTS','u')" 
        type="button" 
        class="v4-btn-every edit-button mb-2 mb-md-0 w-100" 
        (click)="toggleEditMode()">
        <i class="pi pi-pencil me-2"></i>
        {{'Edit' | translator}}
      </button> -->

      <!-- Test Goals Display -->
      <!-- <div class="d-flex align-items-center gap-2 mb-2 mb-md-0">
        <div class="tab-grey-box-2 test-goals-container">
          <div class="test-goals-list">
            <div class="test-goal-item">
              <i class="pi pi-bullseye me-2"></i>
              <div class="test-goal-content">
                <span class="test-goal-label">
                  {{requestForm.get('testGoal')?.value === 'Other' ? 
                    ('Other' | translator) + ': ' + requestForm.get('testGoalOther')?.value : 
                    requestForm.get('testGoal')?.value}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Organizational Unit Display -->
      <div class="d-flex align-items-center gap-2 mb-2 mb-md-0 w-100">
        <div class="tab-grey-box-2 ou-container">
          <div class="d-flex justify-content-between align-items-center">
            <div class="ou-list">
              <!-- Show OUs horizontally -->
              <ng-container *ngFor="let ou of requestForm.get('generalData.ou')?.value?.slice(-8); let i=index">
                <div class="ou-item">
                  <div class="ou-image">
                    <img *ngIf="checkisImg(ou.data); else elseBlock" 
                      src="{{ staticURL }}{{ ou.data }}" 
                      alt="{{ou.label}}"
                      class="ou-img">
                    <ng-template #elseBlock>
                      <i class="{{ ou.data }} ou-icon"></i>
                    </ng-template>
                  </div>
                  <div class="ou-label">{{ou.label}}</div>
                </div>
              </ng-container>
              <div *ngIf="requestForm.get('generalData.ou')?.value?.length > 8" 
                class="ou-more-badge">
                +{{requestForm.get('generalData.ou')?.value?.length - 8}}
              </div>
              <div class="ou-count">
                <span class="ou-count-number">{{requestForm.get('generalData.ou')?.value?.length || 0}}</span>
              </div>
            </div>
          <div class="d-flex align-items-center gap-3">
            <div class="d-flex">
          <button *ngIf="!isEditMode && permission?.status === 'PENDING' && this.hasPermission('PERMISSION_REQUESTS','u')" 
          type="button" 
          class="v4-btn-every edit-button mb-2 mb-md-0 w-100" 
          (click)="toggleEditMode()">
          <i class="pi pi-pencil me-2"></i>
          {{'Edit' | translator}}
        </button>
      </div>
        <div class="status-badge mb-2 mb-md-0" [ngClass]="{
          'status-pending': permission?.status === 'PENDING',
          'status-approved': permission?.status === 'APPROVED',
          'status-rejected': permission?.status === 'REJECTED'
        }">
          <i class="pi" [ngClass]="{
            'pi-clock': permission?.status === 'PENDING',
            'pi-check-circle': permission?.status === 'APPROVED',
            'pi-times-circle': permission?.status === 'REJECTED'
          }"></i>
          {{ permission?.status | translator }}
        </div>
      </div>
        </div>
        </div>
      </div>

      <!-- <div class="status-badge mb-2 mb-md-0" [ngClass]="{
        'status-pending': permission?.status === 'PENDING',
        'status-approved': permission?.status === 'APPROVED',
        'status-rejected': permission?.status === 'REJECTED'
      }">
        <i class="pi" [ngClass]="{
          'pi-clock': permission?.status === 'PENDING',
          'pi-check-circle': permission?.status === 'APPROVED',
          'pi-times-circle': permission?.status === 'REJECTED'
        }"></i>
        {{ permission?.status | translator }}
      </div> -->
    </div>
  </div>

  <form [formGroup]="requestForm" (ngSubmit)="onSubmit()" class="request-form">
    <!-- Add disabled-section class to sections that should be disabled -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFormGroupInvalid('generalData')">
      <h4 class="section-title">{{"General Data" | translator}}</h4>
      <div formGroupName="generalData" class="form-group-container">
        <div class="row p-0">
          <div class="col-md-4 col-12">
            <div class="form-group ppp-dropdown">
              <label class="label-ui" for="requestFor">{{"Request For" | translator}} *</label>
              <p-dropdown id="requestFor" 
                [options]="permissionRequests" 
                formControlName="requestFor"
                [disabled]="lockRequestType && !isViewMode"
                optionLabel="name"
                [class.is-invalid]="isFieldInvalid('generalData.requestFor')"
                placeholder="{{'Select Type' | translator}}"
                [style]="{'width':'100%'}"
                (onChange)="onRequestTypeChange($event)">
              </p-dropdown>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('generalData.requestFor')">
                {{ getFieldError('generalData.requestFor') | translator }}
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="label-ui" for="ou">{{'Entities' | translator}} *</label>
              <p-treeSelect selectionMode="multiple" [metaKeySelection]="false" class="v4-tree my-2" containerStyleClass="w-100" 
                [options]="selectedTreeData" appendTo="body" formControlName="ou" 
                placeholder="{{ 'Select a ou' | translator }}" 
                [filter]="true" [filterInputAutoFocus]="true">
                <ng-template let-node pTemplate="default">
                  <div class="d-flex">
                    <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}" class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                    <ng-template #elseBlock>
                      <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                    </ng-template>
                    <b class="text-nowrap">{{ node.label }}</b>
                  </div>
                </ng-template>
              </p-treeSelect>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="label-ui" for="agencyOrManagement">{{"Agency" | translator}} *</label>
              <input class="input-ui form-control" type="text" id="agencyOrManagement"
                formControlName="agencyOrManagement"
                [class.is-invalid]="isFieldInvalid('generalData.agencyOrManagement')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('generalData.agencyOrManagement')">
                {{ getFieldError('generalData.agencyOrManagement') | translator }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="invalid-feedback" *ngIf="isFormGroupInvalid('generalData')">
        <div *ngFor="let error of getFormGroupErrors('generalData')">{{ error }}</div>
      </div>
    </div>

    <!-- Contact Officer section - always locked -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFormGroupInvalid('contactOfficer')">
      <h4 class="section-title">{{'Contact Officer (Applicant Details)' | translator}}</h4>
      <div formGroupName="contactOfficer" class="form-group-container">
        <div class="row p-0">
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="label-ui" for="contactEmployee">{{"Contact officer name" | translator}} *</label>
              <input class="input-ui form-control" type="text" id="contactEmployee" formControlName="employeeName"
                [class.is-invalid]="isFieldInvalid('contactOfficer.employeeName')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('contactOfficer.employeeName')">
                {{ getFieldError('contactOfficer.employeeName') | translator }}
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="label-ui" for="contactEmail">{{"Email" | translator}} *</label>
              <input class="input-ui form-control" type="email" id="contactEmail" formControlName="email"
                [class.is-invalid]="isFieldInvalid('contactOfficer.email')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('contactOfficer.email')">
                {{ getFieldError('contactOfficer.email') | translator }}
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="label-ui" for="contactMobile">{{"Phone Number" | translator}} *</label>
              <input class="input-ui form-control" type="tel" id="contactMobile" formControlName="mobileNumber"
                [class.is-invalid]="isFieldInvalid('contactOfficer.mobileNumber')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('contactOfficer.mobileNumber')">
                {{ getFieldError('contactOfficer.mobileNumber') | translator }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="invalid-feedback" *ngIf="isFormGroupInvalid('contactOfficer')">
        <div *ngFor="let error of getFormGroupErrors('contactOfficer')">{{ error }}</div>
      </div>
    </div>

    <!-- Question Maker Details section - always locked -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFormGroupInvalid('questionMaker')">
      <h4 class="section-title">{{'Question Maker Details'| translator}}</h4>
      <div formGroupName="questionMaker" class="form-group-container">
        <div class="row p-0">
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="label-ui" for="questionMakerEmployee">{{"question maker name" | translator}} *</label>
              <input class="input-ui form-control" type="text" id="questionMakerEmployee" formControlName="employeeName"
                [class.is-invalid]="isFieldInvalid('questionMaker.employeeName')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('questionMaker.employeeName')">
                {{ getFieldError('questionMaker.employeeName') | translator }}
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="label-ui" for="questionMakerEmail">{{"Email"  | translator}} *</label>
              <input class="input-ui form-control" type="email" id="questionMakerEmail" formControlName="email"
                [class.is-invalid]="isFieldInvalid('questionMaker.email')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('questionMaker.email')">
                {{ getFieldError('questionMaker.email') | translator }}
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label class="label-ui" for="questionMakerMobile">{{'Phone Number' | translator}} *</label>
              <input class="input-ui form-control" type="tel" id="questionMakerMobile" formControlName="mobileNumber"
                [class.is-invalid]="isFieldInvalid('questionMaker.mobileNumber')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('questionMaker.mobileNumber')">
                {{ getFieldError('questionMaker.mobileNumber') | translator }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Test Goal Section -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFieldInvalid('testGoal')">
      <h4 class="section-title">{{'Order Data' | translator}}</h4>
      <div class="d-flex flex-wrap gap-4">
        <div class="form-group w-100">
          <label class="label-ui">{{'Test Goal' | translator}} *</label>
          <div class="checkbox-group w-fill-available radio-flex-ui">
            <div *ngFor="let option of testGoals" class="checkbox-item">
              <input type="radio" [id]="'testGoal_' + option" [value]="option" formControlName="testGoal"
                [class.is-invalid]="isFieldInvalid('testGoal')">
              <label class="label-text-radio" [for]="'testGoal_' + option">{{ option | translator}}</label>
            </div>
          </div>
          <div class="invalid-feedback" *ngIf="isFieldInvalid('testGoal')">
            {{ getFieldError('testGoal') | translator }}
          </div>
          <div class="form-group" *ngIf="requestForm.get('testGoal')?.value === 'Other'">
            <input class="input-ui my-3 form-control" type="text" placeholder="{{'Please specify...' | translator}}" formControlName="testGoalOther"
              [class.is-invalid]="isFieldInvalid('testGoalOther')">
            <div class="invalid-feedback" *ngIf="isFieldInvalid('testGoalOther')">
              {{ getFieldError('testGoalOther') | translator }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Question Data Section - editable in edit mode -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFieldInvalid('questionType') || isFieldInvalid('questionLevel')">
      <h4 class="section-title">{{'Question Data' | translator}}</h4>
      <div class="d-flex flex-wrap">
        <div class="form-group w-100">
          <label class="label-ui">{{'Question Type' | translator}} *</label>
          <div class="question-types-container row p-0">
            <div *ngFor="let category of questionCategories" class="col-md-4 col-12 my-2">
              <div class="question-category h-m-top-bottom p-2">
                <h5 class="category-title">{{ category.category | translator}}</h5>
                <div class="checkbox-group">
                  <div *ngFor="let type of category.types" class="checkbox-item">
                    <input type="checkbox" 
                      [id]="'questionType_' + type.type" 
                      [checked]="isQuestionTypeSelected(type.type)"
                      (change)="onQuestionTypeChange($event, type.type)"
                      [class.is-invalid]="isFieldInvalid('questionType')">
                    <label class="label-text" [for]="'questionType_' + type.type">
                      <i class="pi {{ type.icon }} me-2"></i>
                      {{ type.name | translator }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="invalid-feedback" *ngIf="isFieldInvalid('questionType')">
            {{ getFieldError('questionType') | translator }}
          </div>
        </div>
        <div class="form-group w-100">
          <label class="label-ui">{{'Question Level' | translator}} *</label>
          <div class="radio-group radio-flex-ui">
            <div *ngFor="let option of questionLevelOptions" class="radio-item">
              <input type="radio" 
                [id]="'questionLevel_' + option.value" 
                [value]="option.value" 
                formControlName="questionLevel"
                [class.is-invalid]="isFieldInvalid('questionLevel')">
              <label class="label-text-radio" [for]="'questionLevel_' + option.value">{{ option.label | translator }}</label>
            </div>
          </div>
          <div class="invalid-feedback" *ngIf="isFieldInvalid('questionLevel')">
            {{ getFieldError('questionLevel') | translator }}
          </div>
        </div>
      </div>
    </div>

    <!-- Attendees Details Section - editable in edit mode -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFieldInvalid('numberOfEmployees') || isFieldInvalid('questionsPerModel')">
      <h4 class="section-title">{{'Attendees Details' | translator}}</h4>
      <div class="row p-0">
        <div class="col-md-6 col-12">
          <div class="form-group w-100">
            <label class="label-ui">{{'Number of Employees' | translator}} *</label>
            <div class="radio-group radio-flex-ui w-100">
              <div *ngFor="let option of numberOfEmployeesOptions" class="radio-item">
                <input type="radio" 
                  [id]="'employees_' + option.value" 
                  [value]="option.value"
                  formControlName="numberOfEmployees"
                  [class.is-invalid]="isFieldInvalid('numberOfEmployees')">
                <label class="label-text-radio" [for]="'employees_' + option.value">{{ option.label | translator}}</label>
              </div>
            </div>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('numberOfEmployees')">
              {{ getFieldError('numberOfEmployees') | translator }}
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group w-100">
            <label class="label-ui">{{'Number of questions' | translator}} *</label>
            <div class="radio-group radio-flex-ui w-100">
              <div *ngFor="let option of questionsPerModelOptions" class="radio-item">
                <input type="radio" 
                  [id]="'questions_' + option" 
                  [value]="option" 
                  formControlName="questionsPerModel"
                  [class.is-invalid]="isFieldInvalid('questionsPerModel')">
                <label class="label-text-radio" [for]="'questions_' + option">{{ option  }} سؤال</label>
              </div>
            </div>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('questionsPerModel')">
              {{ getFieldError('questionsPerModel') | translator }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Test Management Section - editable in edit mode -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFieldInvalid('numberOfRegions') || isFieldInvalid('examinationHalls')">
      <h4 class="section-title">{{'Test Management' | translator}}</h4>
      <div class="row p-0">
        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="label-ui">{{'Number of Regions' | translator}} *</label>
            <div class="radio-group radio-flex-ui w-100">
              <div *ngFor="let option of regionsOptions" class="radio-item">
                <input type="radio" 
                  [id]="'regions_' + option.value" 
                  [value]="option.value"
                  formControlName="numberOfRegions"
                  [class.is-invalid]="isFieldInvalid('numberOfRegions')">
                <label class="label-text-radio" [for]="'regions_' + option.value">{{ option.label | translator}}</label>
              </div>
            </div>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('numberOfRegions')">
              {{ getFieldError('numberOfRegions') | translator }}
            </div>
            <div class="form-group my-3" *ngIf="requestForm.get('numberOfRegions')?.value === 'other'">
              <input class="input-ui form-control" type="text" 
                placeholder="{{'Please specify number of regions...' | translator}}"
                formControlName="numberOfRegionsOther" 
                [class.is-invalid]="isFieldInvalid('numberOfRegionsOther')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('numberOfRegionsOther')">
                {{ getFieldError('numberOfRegionsOther') | translator }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="label-ui">{{'Examination Hall' | translator}} *</label>
            <div class="radio-group radio-flex-ui w-100">
              <div *ngFor="let option of examinationHallsOptions" class="radio-item">
                <input type="radio" 
                  [id]="'halls_' + option.value" 
                  [value]="option.value"
                  formControlName="examinationHalls"
                  [class.is-invalid]="isFieldInvalid('examinationHalls')">
                <label class="label-text-radio" [for]="'halls_' + option.value">{{ option.label |translator }}</label>
              </div>
            </div>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('examinationHalls')">
              {{ getFieldError('examinationHalls') | translator }}
            </div>
            <div class="form-group my-3" *ngIf="requestForm.get('examinationHalls')?.value === 'other'">
              <input class="input-ui form-control" type="text" 
                placeholder="{{'Please specify number of halls...' | translator}}"
                formControlName="examinationHallsOther" 
                [class.is-invalid]="isFieldInvalid('examinationHallsOther')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('examinationHallsOther')">
                {{ getFieldError('examinationHallsOther') | translator }}
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-12 col-12">
          <div class="form-group">
            <label class="label-ui">{{'Observers Note' | translator}}</label>
            <textarea class="form-control custom-textarea" 
              formControlName="observersNote"
              rows="6"
              placeholder="{{'Enter any additional notes about observers...' | translator}}"
              [class.is-invalid]="isFieldInvalid('observersNote')">
            </textarea>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('observersNote')">
              {{ getFieldError('observersNote') }}
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Grading Scale Section - editable in edit mode -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFormGroupInvalid('gradingScale')">
      <h4 class="section-title">{{'Suggest grading scale' | translator}}</h4>
      <div formGroupName="gradingScale" class="grading-scale-container">
        <div class="row p-0">
                   
         

          

          <!-- Excellent -->
          <div class="col-md-2 col-12">
            <div class="grade-item" formGroupName="excellent">
              <label class="label-ui v4-color-white">{{'excellent' | translator}}</label>
              <div class="range-inputs d-flex gap-3">
                <div class="w-100">
                  <label class="label-ui v4-color-white">{{'From' | translator}}</label>
                  <input type="number" 
                    formControlName="from" 
                    class="input-ui-left form-control small-input" 
                    min="0" 
                    max="100"
                    [class.is-invalid]="isFieldInvalid('gradingScale.excellent.from')">
                </div>
                <div class="w-100">
                  <label class="label-ui v4-color-white">{{'To' | translator}}</label>
                  <input type="number" 
                    formControlName="to" 
                    class="input-ui-left form-control small-input" 
                    min="0" 
                    max="100"
                    [class.is-invalid]="isFieldInvalid('gradingScale.excellent.to')">
                </div>
              </div>
            </div>
          </div>

          <!-- Very Good -->
          <div class="col-md-2 col-12">
            <div class="grade-item" formGroupName="veryGood">
              <label class="label-ui v4-color-white">{{'veryGood' | translator}}</label>
              <div class="range-inputs d-flex gap-3">
                <div class="w-100">
                  <label class="label-ui v4-color-white">{{'From' | translator}}</label>
                  <input type="number" 
                    formControlName="from" 
                    class="input-ui-left form-control small-input" 
                    min="0" 
                    max="100"
                    [class.is-invalid]="isFieldInvalid('gradingScale.veryGood.from')">
                </div>
                <div class="w-100">
                  <label class="label-ui v4-color-white">{{'To' | translator}}</label>
                  <input type="number" 
                    formControlName="to" 
                    class="input-ui-left form-control small-input" 
                    min="0" 
                    max="100"
                    [class.is-invalid]="isFieldInvalid('gradingScale.veryGood.to')">
                </div>
              </div>
            </div>
          </div>

           <!-- Good -->
           <div class="col-md-2 col-12">
            <div class="grade-item" formGroupName="good">
              <label class="label-ui v4-color-white">{{'Good' | translator}}</label>
              <div class="range-inputs d-flex gap-3">
                <div class="w-100">
                  <label class="label-ui v4-color-white">{{'From' | translator}}</label>
                  <input type="number" 
                    formControlName="from" 
                    class="input-ui-left form-control small-input" 
                    min="0" 
                    max="100"
                    [class.is-invalid]="isFieldInvalid('gradingScale.good.from')">
                </div>
                <div class="w-100">
                  <label class="label-ui v4-color-white">{{'To' | translator}}</label>
                  <input type="number" 
                    formControlName="to" 
                    class="input-ui-left form-control small-input" 
                    min="0" 
                    max="100"
                    [class.is-invalid]="isFieldInvalid('gradingScale.good.to')">
                </div>
              </div>
            </div>
          </div>

           <!-- Not Passed -->
           <div class="col-md-2 col-12">
            <div class="grade-item" formGroupName="notPassed">
              <label class="label-ui v4-color-white">{{'Not Passed' | translator}}</label>
              <div class="range-inputs d-flex gap-3">
                <div class="w-100">
                  <label class="label-ui v4-color-white">{{'From' | translator}}</label>
                  <input type="number" 
                    formControlName="from" 
                    class="input-ui-left form-control small-input" 
                    min="0" 
                    max="100"
                    [class.is-invalid]="isFieldInvalid('gradingScale.notPassed.from')">
                </div>
                <div class="w-100">
                  <label class="label-ui v4-color-white">{{'To' | translator}}</label>
                  <input type="number" 
                    formControlName="to" 
                    class="input-ui-left form-control small-input" 
                    min="0" 
                    max="100"
                    [class.is-invalid]="isFieldInvalid('gradingScale.notPassed.to')">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="invalid-feedback" *ngIf="isFormGroupInvalid('gradingScale')">
        <div *ngFor="let error of getFormGroupErrors('gradingScale')">{{ error }}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-12">
        <div class="form-group">
          <label class="label-ui">{{'Observers Note' | translator}}</label>
          <textarea class="form-control custom-textarea" 
            formControlName="observersNote"
            rows="6"
            placeholder="{{'Enter any additional notes about observers...' | translator}}"
            [class.is-invalid]="isFieldInvalid('observersNote')">
          </textarea>
          <div class="invalid-feedback" *ngIf="isFieldInvalid('observersNote')">
            {{ getFieldError('observersNote') | translator }}
          </div>
        </div>
      </div>
    </div>

    <!-- Test Schedule Section -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode" [class.is-invalid]="isFieldInvalid('testDurationMinutes') || isFieldInvalid('testEntries')">
      <h4 class="section-title">{{'Test Schedule' | translator}}</h4>
      <div formArrayName="testEntries" class="test-entries-container">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">{{'Sessions' | translator}} *</h5>
          <button type="button" class="v4-btn-every" (click)="addTestEntry()" *ngIf="canAddTestEntry()">
            <i class="pi pi-plus"></i> {{'Add Test Session' | translator}}
          </button>
        </div>

        <div *ngIf="testEntries.length === 0" class="alert alert-warning">
          {{'At least one test session is required' | translator}}
        </div>

        <div *ngFor="let entry of testEntries.controls; let i = index" [formGroupName]="i" 
          class=""
          [class.is-invalid]="isTestEntryFieldInvalid(i, 'testName') || isTestEntryFieldInvalid(i, 'testDate') || 
                             isTestEntryFieldInvalid(i, 'startTime') || isTestEntryFieldInvalid(i, 'endTime')">
          
          <!-- Remove Button
          <button type="button" 
            class="btn btn-danger btn-sm position-absolute" 
            style="top: 10px; right: 10px;"
            (click)="removeTestEntry(i)" 
            *ngIf="testEntries.length > 1"
            title="Remove Test Session">
            <i class="pi pi-trash"></i>
          </button> -->

          <div class="row">
            <!-- Test Name -->
            <div class="col-md-3 col-12 mb-3">
              <div class="form-group">
                <label class="label-ui">{{'Test Name' | translator}} *</label>
                <input class="input-ui form-control" 
                  type="text" 
                  formControlName="testName"
                  placeholder="{{'Enter test name' | translator}}"
                  [class.is-invalid]="isTestEntryFieldInvalid(i, 'testName')">
                <div class="invalid-feedback" *ngIf="isTestEntryFieldInvalid(i, 'testName')">
                  {{ getFieldError('testName') | translator }}
                </div>
              </div>
            </div>

            <!-- Test Date -->
            <div class="col-md-2 col-12 mb-3">
              <div class="form-group">
                <label class="label-ui">{{'Test Date' | translator}} *</label>
                <input class="input-ui form-control" 
                  type="date" 
                  formControlName="testDate"
                  [min]="getMinDate()"
                  [class.is-invalid]="isTestEntryFieldInvalid(i, 'testDate')">
                <div class="invalid-feedback" *ngIf="isTestEntryFieldInvalid(i, 'testDate')">
                  {{ getFieldError('testDate') | translator }}
                </div>
              </div>
            </div>

            <!-- Start Time -->
            <div class="col-md-2 col-12 mb-3">
              <div class="form-group">
                <label class="label-ui">{{'Start Time' | translator}} *</label>
                <input class="input-ui form-control" 
                  type="time" 
                  formControlName="startTime"
                  [class.is-invalid]="isTestEntryFieldInvalid(i, 'startTime')">
                <div class="invalid-feedback" *ngIf="isTestEntryFieldInvalid(i, 'startTime')">
                  {{ getFieldError('startTime') | translator }}
                </div>
              </div>
            </div>

            <!-- End Time -->
            <div class="col-md-2 col-12 mb-3">
              <div class="form-group">
                <label class="label-ui">{{'End Time' | translator}} *</label>
                <input class="input-ui form-control" 
                  type="time" 
                  formControlName="endTime"
                  [class.is-invalid]="isTestEntryFieldInvalid(i, 'endTime')">
                <div class="invalid-feedback" *ngIf="isTestEntryFieldInvalid(i, 'endTime')">
                  {{ getFieldError('endTime') | translator }}
                </div>
              </div>
            </div>

            <!-- Attempt Time (for ASSESSMENT only) -->
            <div class="col-md-3 col-12 mb-3" *ngIf="isAssessmentRequest()">
              <div class="form-group pos-rel">
                <div class="pos-abs-cross" (click)="removeTestEntry(i)" *ngIf="canRemoveTestEntry(i)" title="Remove Test Session"><i class="pi pi-trash cross-font"></i></div>
                <label class="label-ui">{{'Attempt Time (mintues)' | translator}} *</label>
                <input class="input-ui form-control" 
                  type="number" 
                  formControlName="attemptTime"
                  min="1"
                  placeholder="{{'Attempt Time (mintues)' | translator}}"
                  [class.is-invalid]="isTestEntryFieldInvalid(i, 'attemptTime')">
                <div class="invalid-feedback" *ngIf="isTestEntryFieldInvalid(i, 'attemptTime')">
                  {{ getFieldError('attemptTime') | translator }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Test Report Section - editable in edit mode -->
    <div class="form-section" [class.disabled-section]="isViewMode && !isEditMode">
      <h4 class="section-title">{{'Test Report' | translator}}</h4>
      <div class="d-flex flex-wrap gap-4">
        <div class="form-group">
          <div class="checkbox-item">
            <input type="checkbox" id="detailedReport" formControlName="detailedReport">
            <label class="label-ui" for="detailedReport">✓ {{'(Detailed) Delivered within 15 days of the test' | translator}}</label>
          </div>
        </div>
        <div class="form-group">
          <div class="checkbox-item">
            <input type="checkbox" id="yearlyReport" formControlName="yearlyReport">
            <label class="label-ui" for="yearlyReport">{{'Given one year after the test is conducted by two days' | translator}}</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Comments and Agreement Section - Only show in view mode when status is PENDING -->
    <ng-container *ngIf="isViewMode  && !isEditMode && this.hasPermission('PERMISSION_REQUESTS_APPROVE','a') || permission?.status === 'A' ">
      <!-- Comments Section -->
      <div class="content-white">
        <p class="label-ui">{{'Please add comments' | translator}}</p>
        <div class="form-floating">
          <textarea
            class="form-control custom-textarea-white wwww" 
            formControlName="comments"
            rows="6"
            [class.is-invalid]="isFieldInvalid('comments')"
            placeholder="{{'Leave a comment here' | translator}}" 
            id="comments"
            [attr.disabled]="false">
          </textarea>
          <div class="invalid-feedback" *ngIf="isFieldInvalid('comments')">
            {{getFieldError('comments') | translator}}
          </div>
        </div>
      </div>

      <!-- Agreement Section -->
      <div class="content-white">
        <p class="label-ui">{{'Please confirm' | translator}}</p>
        <div class="text-radio-bar">
          <div class="d-flex align-items-center">
            <input 
              class="form-check-input" 
              type="checkbox" 
              formControlName="agreement"
              [class.is-invalid]="isFieldInvalid('agreement')"
              id="agreement"
              style="cursor: pointer; pointer-events: auto; opacity: 1;">
            <label for="agreement" class="ms-2 mb-0">{{'Are u sure to approve permission' | translator}}</label>
          </div>
          <div class="invalid-feedback" *ngIf="isFieldInvalid('agreement')">
            {{getFieldError('agreement') | translator}}
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="d-flex justify-content-center gap-2 mt-5 action-buttons-container">
        <div class="v4-btn-every" (click)="handlePermissionAction(permissionId, 'approve')">{{'Approve' | translator}}</div>
        <div class="v4-btn-every" (click)="handlePermissionAction(permissionId, 'reject')">
         {{'Reject' | translator}}</div>
      </div>
    </ng-container>

    <!-- Action Buttons at bottom -->
    <div class="form-section bg-theme d-flex justify-content-center w-100 my-5" *ngIf="!hideNativeActions">
      <!-- Submit Button - show in both edit mode and normal form view -->
      <button type="submit" class="v4-btn-every m-1" *ngIf="isEditMode || !isViewMode">
        {{ isEditMode ? ('Save Changes' | translator) : ('Submit' | translator) }}
      </button>

      <!-- Reset Button (only when creating new request) -->
      <button *ngIf="!isViewMode" 
        type="button" 
        class="v4-btn-every m-1" 
        (click)="resetForm()">
        {{'Reset' | translator}}
      </button>

      <!-- Cancel Edit Button - only show in edit mode -->
      <button *ngIf="isViewMode && isEditMode" 
        type="button" 
        class="v4-btn-every m-1" 
        (click)="cancelEdit()">
        {{'Cancel Edit' | translator}}
      </button>
    </div>
  </form>
</div>


